import React, { useState } from 'react';

import { ClickAwayListener, IconButton, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import EditIcon from '@material-ui/icons/Edit';

import clsx from 'clsx';
import { useDebouncedCallback } from 'use-debounce';

import { textInputTitleStyles } from './styles';
import TextInput from './text-input';

export const DoneEditingButton = ({ classes, setIsEditing, finalValue }) => (
  <IconButton
    className={clsx(classes.saveCheck, { [classes.saveCheckDirty]: Boolean(finalValue) })}
    onClick={() => {
      setIsEditing(false);
    }}
  >
    <CheckCircleOutlineIcon />
  </IconButton>
);

export function EditableTextInput(props) {
  const {
    placeholder = 'Enter text',
    value: initialValue = '',
    onChange: onChangeProp,
    onKeyPress: onKeyPressProp,
    classes,
    className,
    isEditing: isEditingProp = false,
    keyValuesToWatch = [],
    typographyVariant = 'subtitle1',
    delay = 2,
    ...other
  } = props;
  const [value, setValue] = useState(initialValue);
  const [isEditing, setIsEditing] = useState(isEditingProp);

  const handleOnChangeDebounce = useDebouncedCallback(value => {
    setValue(value);
    if (typeof onChangeProp === 'function') {
      onChangeProp({ target: { value } });
    }
  }, delay);

  function handleEditingStop() {
    if (isEditing) {
      setIsEditing(false);
    }
  }

  function handleChange(event) {
    handleOnChangeDebounce(event.target.value);
  }

  function handleKeyPress(event) {
    handleEditingStop();
    if (typeof onKeyPressProp === 'function') {
      onKeyPressProp(event);
    }
  }

  return (
    <ClickAwayListener onClickAway={handleEditingStop}>
      <div className={clsx(classes.root, className)}>
        {isEditing ? (
          <TextInput
            delay={delay}
            value={value}
            placeholder={placeholder}
            onChange={handleChange}
            onKeyPress={handleKeyPress}
            endAdornment={<DoneEditingButton finalValue={value} setIsEditing={setIsEditing} classes={classes} />}
            autoFocus
            keyValuesToWatch={keyValuesToWatch}
            {...other}
          />
        ) : (
          <div
            onClick={() => setIsEditing(true)}
            data-testid='saved-field'
            className={clsx('Saved-Text', classes.savedText)}
          >
            <Typography variant={typographyVariant}>{value || placeholder}</Typography>
            <EditIcon />
          </div>
        )}
      </div>
    </ClickAwayListener>
  );
}
export default withStyles(textInputTitleStyles)(EditableTextInput);
